import React from "react";
import { Link } from "react-router-dom";
import { AppHeader } from "@/components/AppHeader";
import { Hero } from "@/components/Hero";
import { Explore } from "@/components/Explore";
import { FeaturedSpots } from "@/components/FeaturedSpots";
import { useSections } from "@/lib/sections";
import { useAuth, homeFor } from "@/contexts/AuthContext";
import { usePrefs } from "@/contexts/PrefsContext";
import { FloatingWhatsApp } from "@/components/PlatformContact";
import { Onboarding } from "@/components/Onboarding";

export default function Landing() {
  const { user } = useAuth();
  const { t } = usePrefs();
  const sec = useSections();
  return (
    <div className="min-h-screen bg-background">
      <AppHeader
        nav={
          user ? (
            <Link to={homeFor(user.role)} data-testid="landing-dashboard-link" className="h-10 px-4 inline-flex items-center rounded-full bg-accent font-bold text-sm">
              {t("common.dashboard")}
            </Link>
          ) : null
        }
      />
      <main className="mx-auto max-w-6xl px-4 py-5 space-y-10 pb-16">
        <Hero />
        {sec.mode && sec.spots && <FeaturedSpots />}
        {sec.mode && sec.events && <Explore />}
        <footer className="pt-6 border-t flex flex-wrap gap-4 justify-between text-sm text-muted-foreground">
          <span>{t("tagline")}</span>
          <Link to="/partner/login" data-testid="footer-partner-login-link" className="font-semibold hover:text-primary">
            {t("auth.partnerLink")}
          </Link>
        </footer>
      </main>
      <FloatingWhatsApp />
      <Onboarding />
    </div>
  );
}
